
import { Star } from 'lucide-react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  rating: number;
}

const TestimonialCard = ({ quote, author, role, rating }: TestimonialCardProps) => (
  <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
    <div className="flex mb-4">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className={`h-5 w-5 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} />
      ))}
    </div>
    <blockquote className="text-gray-700 mb-4">"{quote}"</blockquote>
    <div className="flex items-center">
      <div className="h-10 w-10 rounded-full bg-realestate-tag flex items-center justify-center text-realestate-blue font-medium">
        {author.charAt(0)}
      </div>
      <div className="ml-3">
        <p className="font-medium text-gray-900">{author}</p>
        <p className="text-sm text-gray-500">{role}</p>
      </div>
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <section className="py-16 bg-realestate-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-realestate-darkblue mb-2">What Our Clients Say</h2>
          <p className="text-gray-600">Hear from property owners and investors who've worked with us in Colombo</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <TestimonialCard 
            quote="Commercial Property LK helped me find the perfect office space for my growing business in Colombo. Their team was responsive and understood exactly what I needed."
            author="Michael Fernando"
            role="CEO, TechFusion"
            rating={5}
          />
          <TestimonialCard 
            quote="Listing my commercial property with Commercial Property LK resulted in a faster sale than I expected. Their market knowledge of Sri Lanka is impressive."
            author="Sarah Perera"
            role="Property Investor"
            rating={5}
          />
          <TestimonialCard 
            quote="The data and analytics provided by Commercial Property LK gave me confidence in my investment decisions in Colombo. I highly recommend their services."
            author="Ravi Mendis"
            role="Real Estate Developer"
            rating={4}
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
